import api from '../api/client';

/**
 * Creates a new SSO configuration (admin only).
 * @param {object} data - SSO config fields
 * @returns {Promise<object>}
 */
const configure = async (data) => {
    const res = await api.post('/api/sso/configure', data);
    return res?.data;
};

/**
 * Lists SSO configurations for an app (admin only).
 * @param {string} appId
 * @returns {Promise<Array>}
 */
const getConfigurations = async (appId) => {
    const res = await api.get('/api/sso/configurations', { params: { app_id: appId } });
    return res?.data?.data || [];
};

/**
 * Updates an existing SSO configuration (admin only).
 * @param {object} data - SSO config fields including sso_config_id
 * @returns {Promise<object>}
 */
const update = async (data) => {
    const res = await api.post('/api/sso/update', data);
    return res?.data;
};

/**
 * Soft-deletes an SSO configuration (admin only).
 * @param {string} ssoConfigId
 * @returns {Promise<object>}
 */
const deleteSSOConfig = async (ssoConfigId) => {
    const res = await api.post('/api/sso/delete', { sso_config_id: ssoConfigId });
    return res?.data;
};

/**
 * Lists enabled SSO providers for a given app (public, no auth).
 * Used on the login page to show SSO buttons.
 * @param {string} appId
 * @returns {Promise<Array<{ sso_config_id: string, provider_name: string, provider_slug: string, protocol: string }>>}
 */
const getProviders = async (appId) => {
    const res = await api.get(`/api/sso/providers/${appId}`);
    return res?.data?.data || [];
};

const ssoService = {
    configure,
    getConfigurations,
    update,
    delete: deleteSSOConfig,
    getProviders,
};

export default ssoService;
